import { defineStore } from 'pinia'

interface SnackbarMessage {
  severity: 'info' | 'success' | 'danger'
  title: {
    langkey: string
    params: Record<string, any>
  }
  timeout?: number
  persistent?: boolean
}

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    snackbarList: [] as SnackbarMessage[],
  }),

  getters: {
    getSnackbarList: (state) => state.snackbarList,
  },

  actions: {
    setSnackbar(message: SnackbarMessage) {
      this.snackbarList.push(message)
    },

    deleteSnackbar() {
      this.snackbarList.shift()
    },

    clearAll() {
      this.snackbarList = []
    },
  },
})
